import React from 'react'
import classes from "./styles.module.scss";
import TraitCard from './TraitCard';
import {trait_01, trait_02, trait_03, trait_04} from '../../../assets/images';

export interface TraitsCardsProps extends React.InputHTMLAttributes<HTMLInputElement> {
  title: string;
  subtitle?: string;
}

const TraitsCards: React.FC<TraitsCardsProps> = ({ title, subtitle}) => {
  return (
    <div className={classes.TraitsCards}>
      <div className={classes.title}>{title}</div>
      <div className={classes.subtitle}>{subtitle}</div>

      <div className={classes.cardsContainer}>
        <TraitCard
          image={trait_01}
          icon="traitCube"
          title="Generate"
          text="Turn plain text into ready-to-share social posts — powered by AI creativity and automation."
        />
        <TraitCard
          image={trait_02}
          icon="traitRoundImage"
          title="Visualize"
          text="Bring your words to life with stunning, AI-generated images that match your message’s tone and context."
        />
        <TraitCard
          image={trait_03}
          icon="traitGrid"
          title="Compose"
          text="Craft compelling captions and layouts tailored for every platform — Instagram, LinkedIn, X, and more."
        />
        <TraitCard
          image={trait_04}
          icon="traitGlobe"
          title="Publish"
          text="Instantly share or schedule posts across your social channels with one click."
        />
      </div>
    </div>
  )
}

export default TraitsCards;